import { useAuth } from "context/AuthContext";
import { routesPath } from "conts/routes";
import { instructorRoute } from "pages/instructor/instructor.routes";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { LogoIcon } from "ui/icons";
import { initialFilters, useFilters } from "context/FilterContext";

export const HeaderLogo = ({ primary, mobile }) => {
    const { setFilters } = useFilters()
    const { userRole } = useAuth();
    const route = userRole === 1 ? routesPath.main : instructorRoute.homeInstructor
    return (
        <Logo mobile={mobile}>
            <Link to={route} onClick={() => {
                setFilters(initialFilters)
            }}>
                <LogoIcon color={primary ? "white" : "blue"} />
            </Link>
        </Logo>
    );
};

const Logo = styled.div`
    z-index: 1;
    width: 99px;
    height: 100%;

    svg {
        width: 100%;
        height: 17px;
        min-width: 50px;
    }

    a {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media (min-width: 768px) {
        width: 147px;
        svg {
            height: 26px;
        }
    }

    @media (min-width: 1200px) {
        width: 164px;
        svg {
            height: 20px;
        }
    }

    @media (max-width: 1023px) {
        display: ${({ mobile }) => mobile ? "flex" : "none"} ;
    }
`;
